import React, { useMemo, useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { EVENT_CODES, GOODS_TYPES } from 'constants/sales'
import { RU, US } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import useCurrentPromoEvent from 'hooks/useCurrentPromoEvent'
import createNumberFormatter from 'utils/createPriceFormatter'
import { useGoods } from 'modules/Home/components/Carousel/hooks'
import AddAndGoToCart from 'containers/AddAndGoToCart'

import {
  Wrapper,
  Container,
  Title,
  Content,
  List,
  ListItem,
  Actions,
  Image,
  Event,
  DiscountBadge,
  EventLabel,
  OldPrice,
  PriceAndButton,
  Price,
  SplitBadgeWrapper,
} from './styles'
import { ButtonInner } from '../DAboutFirstBlock/styles'

function useTheme(name, locale, isWgs, isBiome) {
  return useMemo(() => {
    switch (name) {
      case EVENT_CODES.VALENTINES_23:
        return {
          bg: '#E85D74',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.VALENTINES_23,
          badgeBg: 'transparent',
          badgeColor: 'white',
          labelBg: '#C32A20',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.FEBRUARY_23:
        return {
          bg: '#6E7CC4',
          color: 'white',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.FEBRUARY_23,
          badgeBg: 'transparent',
          badgeColor: 'white',
          labelBg: 'rgba(255,255,255,0.3)',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.WOMENS_DAY_23:
        return {
          bg: '#714232',
          color: 'white',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.WOMENS_DAY_23,
          badgeBg: 'transparent',
          badgeColor: '#F8A9C9',
          labelBg: '#F8A9C9',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.HEALTH_DAY_23:
        return {
          bg: isWgs ? 'black' : '#EBEFF0',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.HEALTH_DAY_23,
          badgeBg: 'transparent',
          badgeColor: 'pink',
          labelBg: 'pink',
          mark: 'pink-mark',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.DNA_DAY_23:
        return {
          bg: isWgs ? 'black' : '#6A48CB',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.DNA_DAY_23,
          badgeBg: 'transparent',
          badgeColor: 'lightYellow',
          labelBg: 'lightYellow',
          mark: 'light-green-mark',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.MAY_PROMO_23:
        return {
          bg: isWgs ? 'black' : '#E0E1E6',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.MAY_PROMO_23,
          badgeBg: 'transparent',
          badgeColor: 'pink',
          labelBg: 'pink',
          mark: 'pink-mark',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.CHILD_DAY_23:
        return {
          bg: isWgs ? 'black' : '#DED6E9',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.CHILD_DAY_23,
          badgeBg: 'transparent',
          badgeColor: 'pink',
          labelBg: 'pink',
          mark: 'pink-mark',
          labelColor: 'white',
          customStylesDesktop: `
            max-width: 445px;
          `,
          customStylesTab: `
            max-width: 324px;
          `,
        }
      case EVENT_CODES.FAMILY_DAY_23:
        return {
          bg: isWgs ? 'black' : '#FECC49',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.FAMILY_DAY_23,
          badgeBg: 'transparent',
          badgeColor: 'pink',
          labelBg: 'pink',
          mark: 'pink-mark',
          labelColor: 'white',
          customStylesDesktop: `
            max-width: 454px;
          `,
          customStylesTab: `
            max-width: 324px;
          `,
        }
      case EVENT_CODES.AUGUST_23:
        return {
          bg: isWgs ? 'black' : '#FF8AA2',
          color: isWgs ? 'white' : 'white',
          button: isWgs ? 'white' : 'white',
          textButton: isWgs ? 'black' : 'black',
          illustration: EVENT_CODES.AUGUST_23,
          badgeBg: 'transparent',
          badgeColor: '#F1F52F',
          labelBg: '#F1F52F',
          labelColor: 'black',
          mark: 'pink-mark',
          customStylesDesktop: `
            max-width: 454px;
          `,
          customStylesTab: `
            max-width: 324px;
          `,
        }
      case EVENT_CODES.WOMENS_DAY_24:
        return {
          bg: '#F9F4EE',
          color: 'black',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.WOMENS_DAY_24,
          badgeBg: 'transparent',
          badgeColor: '#8E8DFF',
          labelBg: '#8E8DFF',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.HEALTH_DAY_24:
        return {
          bg: '#C8CAC9',
          color: 'black',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.HEALTH_DAY_24,
          badgeBg: 'transparent',
          badgeColor: '#7645EF',
          labelBg: '#7645EF',
          // mark: 'pink-mark',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.DNA_DAY_24:
        return {
          bg: '#232323',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.DNA_DAY_24,
          badgeBg: '#FF68B9',
          badgeColor: 'white',
          labelBg: '#FF68B9',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.KNOWLEDGE_DAY_24:
        return {
          bg: isWgs ? 'black' : '#CA7A4F',
          color: 'white',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.KNOWLEDGE_DAY_24,
          badgeBg: 'transparent',
          badgeColor: '#F1F52F',
          labelBg: '#F1F52F',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.TEACHERS_DAY_24:
        return {
          bg: isWgs ? 'black' : '#F5A7B6',
          color: 'white',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.TEACHERS_DAY_24,
          badgeBg: 'transparent',
          badgeColor: '#EAFC7A',
          labelBg: '#EAFC7A',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.BLACK_FRIDAY_24:
        return {
          bg: isWgs ? 'black' : '#131313',
          color: 'white',
          button: isWgs ? 'white' : 'white',
          textButton: isWgs ? 'black' : 'black',
          illustration: EVENT_CODES.BLACK_FRIDAY_24,
          badgeBg: 'transparent',
          badgeColor: '#D0FF15',
          labelBg: '#D0FF15',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.PRE_NEW_YEAR_24:
        return {
          bg: isWgs ? 'black' : '#D33228',
          color: 'white',
          button: isWgs ? 'white' : 'white',
          textButton: isWgs ? 'black' : 'black',
          illustration: EVENT_CODES.PRE_NEW_YEAR_24,
          badgeBg: 'transparent',
          badgeColor: isWgs ? '#FFE060' : 'white',
          labelBg: isWgs ? '#FFE060' : 'white',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.CYBER_MONDAY_25:
        return {
          bg: 'black',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.CYBER_MONDAY_25,
          badgeBg: 'transparent',
          badgeColor: '#00BEFF',
          labelBg: '#00BEFF',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.VALENTINES_25:
        return {
          bg: '#E85D74',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.VALENTINES_25,
          badgeBg: 'transparent',
          badgeColor: 'white',
          labelBg: '#C32A20',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.WOMENS_DAY_25:
        return {
          bg: '#B58FE8',
          color: 'white',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.WOMENS_DAY_25,
          badgeBg: 'transparent',
          badgeColor: '#EAFC7A',
          labelBg: '#EAFC7A',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.WGS_SALE_25:
        if (isWgs) {
          return {
            bg: '#000000',
            color: 'white',
            button: 'white',
            textButton: 'black',
            illustration: EVENT_CODES.WGS_SALE_25,
            badgeBg: 'transparent',
            badgeColor: '#7645EF',
            labelBg: '#7645EF',
            labelColor: 'white',
            customStylesDesktop: `
            padding-bottom: 70%;
          `,
            customStylesTab: `
            padding-bottom: 80%;
          `,
            customStylesMob: `
            padding-bottom: 60%;
          `,
          }
        } else {
          break
        }
      case EVENT_CODES.FAMILY_DAY_25:
        return {
          bg: isWgs ? 'black' : '#FDE0BC',
          color: isWgs ? 'white' : '#7645EF',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.FAMILY_DAY_25,
          badgeBg: 'transparent',
          badgeColor: '#7645EF',
          labelBg: '#7645EF',
          labelColor: 'white',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.AUGUST_PROMO_25:
        return {
          bg: isWgs ? 'black' : '#BDA7FF',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.AUGUST_PROMO_25,
          badgeBg: 'transparent',
          badgeColor: '#FFFF95',
          labelBg: '#FFFF95',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.YOUTH_DAY_25:
        if (isWgs || isBiome) {
          return {
            bg: '#BFD3F4',
            color: 'black',
            button: 'black',
            textButton: 'white',
            illustration: EVENT_CODES.YOUTH_DAY_25,
            badgeBg: 'transparent',
            badgeColor: '#EBFF75',
            labelBg: '#EBFF75',
            labelColor: 'black',
            customStylesDesktop: `
            padding-bottom: 70%;
          `,
            customStylesTab: `
            padding-bottom: 80%;
          `,
            customStylesMob: `
            padding-bottom: 60%;
          `,
          }
        } else break
      case EVENT_CODES.TELEGRAM_DAY_25:
        return {
          bg: 'black',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.TELEGRAM_DAY_25,
          badgeBg: 'transparent',
          badgeColor: '#FEB35F',
          labelBg: '#FEB35F',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.MICROBIOME_SALE_25:
        return {
          bg: isWgs ? 'black' : '#F1D8C7',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.MICROBIOME_SALE_25,
          badgeBg: 'transparent',
          badgeColor: '#7645EF',
          labelBg: '#7645EF',
          labelColor: 'white',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.BUNDLE_SALE_25:
        return {
          bg: isWgs ? '#191919' : '#43413E',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.BUNDLE_SALE_25,
          badgeBg: 'transparent',
          badgeColor: '#FAC8A5',
          labelBg: '#FAC8A5',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.BLACK_FRIDAY_25:
        return {
          bg: '#010F00',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.BLACK_FRIDAY_25,
          badgeBg: 'transparent',
          badgeColor: '#2DFE79',
          labelBg: '#2DFE79',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.NEW_YEAR_25:
        return {
          bg: isWgs ? '#1D1919' : '#A8231E',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.NEW_YEAR_25,
          badgeBg: 'transparent',
          badgeColor: '#E3CD9E',
          labelBg: '#E3CD9E',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.UNLOCK_26:
        return {
          bg: isWgs ? '#1D1919' : '#FF42DC',
          color: 'white',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.UNLOCK_26,
          badgeBg: 'transparent',
          badgeColor: '#FFFFFF',
          labelBg: isWgs ? '#FF42DC' : '#FFFFFF',
          labelColor: 'black',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.VALENTINES_26:
        return {
          bg: isWgs ? '#1D1919' : '#F6667E',
          color: 'white',
          button: 'white',
          textButton: 'black',
          illustration: EVENT_CODES.VALENTINES_26,
          badgeBg: 'transparent',
          badgeColor: '#FFFFFF',
          labelBg: isWgs ? '#F6667E' : '#000000',
          labelColor: isWgs ? 'black' : 'white',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.WOMENS_DAY_26:
        return {
          bg: isWgs ? '#1D1919' : '#F3F0E8',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.WOMENS_DAY_26,
          badgeBg: 'transparent',
          badgeColor: '#f8838d',
          labelBg: 'linear-gradient(90deg,#FF703A, #FCA1FF)',
          labelColor: 'white',
          mark: 'yellow-mark',
          customStylesDesktop: `
          padding-bottom: 70%;
        `,
          customStylesTab: `
          padding-bottom: 80%;
        `,
          customStylesMob: `
          padding-bottom: 60%;
        `,
        }
      case EVENT_CODES.DNA_DAY_26:
        if (isWgs) {
          return {
            bg: '#262C33',
            color: 'white',
            button: 'white',
            textButton: 'black',
            illustration: EVENT_CODES.DNA_DAY_26,
            badgeBg: 'transparent',
            badgeColor: 'white',
            labelBg: '#B99EFF',
            labelColor: 'black',
            customStylesDesktop: `
              padding-bottom: 70%;
            `,
            customStylesTab: `
              padding-bottom: 80%;
            `,
            customStylesMob: `
              padding-bottom: 60%;
            `,
          }
        }

        return {
          bg: '#B99EFF',
          color: 'white',
          button: 'black',
          textButton: 'white',
          illustration: EVENT_CODES.DNA_DAY_26,
          badgeBg: 'transparent',
          badgeColor: 'white',
          labelBg: 'white',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
      case EVENT_CODES.JUNE_BUNDLE_26:
        return {
          bg: isWgs ? '#42302e' : '#bee6ff',
          color: isWgs ? 'white' : 'black',
          button: isWgs ? 'white' : 'black',
          textButton: isWgs ? 'black' : 'white',
          illustration: EVENT_CODES.JUNE_BUNDLE_26,
          badgeBg: 'transparent',
          badgeColor: 'white',
          labelBg: 'white',
          labelColor: 'black',
          customStylesDesktop: `
            padding-bottom: 70%;
          `,
          customStylesTab: `
            padding-bottom: 80%;
          `,
          customStylesMob: `
            padding-bottom: 60%;
          `,
        }
    }

    if (locale === US) {
      return {
        bg: '#DEECEE',
        color: 'black',
        button: 'black',
        textButton: 'white',
        illustration: 'default',
        accentBg: 'funGreen',
        accentColor: 'white',
        badgeBg: 'transparent',
        badgeColor: 'pink',
        labelBg: 'pink',
        mark: 'pink-mark',
        labelColor: 'white',
        customStylesDesktop: `
            max-width: 499px;
            background-position: bottom;
          `,
        customStylesTab: `
            max-width: 390px;
          `,
      }
    }

    return {
      bg: 'lilac',
      color: 'white',
      button: 'green',
      textButton: 'rgba(0,0,0,.74)',
      illustration: 'default',
      accentBg: 'funGreen',
      accentColor: 'white',
      badgeBg: 'transparent',
      badgeColor: 'softYellow',
      labelBg: 'pink',
      mark: 'soft-yellow-mark',
      labelColor: 'white',
      customStylesDesktop: `
            max-width: 700px;
          `,
      customStylesMob: `
            min-height: 204px;
          `,
    }
  }, [name, locale, isWgs, isBiome])
}

const JUNE_BUNDLE_PRODUCT_LISTS = {
  [GOODS_TYPES.dna]: [
    'Происхождение и&nbsp;поиск родственников до&nbsp;8 поколения',
    '320+ наследственных заболеваний и&nbsp;риски развития 20 распространенных заболеваний',
    'Непереносимость лактозы и&nbsp;глютена, алкоголя и&nbsp;метаболизм кофеина',
    'Уровень витаминов A, E, B5, B6, B12 и&nbsp;минералов (железо, кальций и&nbsp;другие)',
    'Риски по&nbsp;3 спортивным травмам для подбора оптимальных тренировок и&nbsp;уровни 4 веществ, связанных со&nbsp;спортивными показателями',
    'Уникальные особенности вашего организма и&nbsp;внешности, заложенные в&nbsp;ДНК',
    'Мужское и&nbsp;женское здоровье',
    'Персональные рекомендации по&nbsp;анализам, обследованиям и&nbsp;врачам',
    'Комплексный подход к&nbsp;здоровью: рекомендации по&nbsp;питанию и&nbsp;образу жизни',
  ],
  [GOODS_TYPES.biome]: [
    'Разнообразие и&nbsp;соотношение 1338 видов бактерий кишечника&nbsp;&mdash; это в&nbsp;20 раз больше, чем в&nbsp;методе ХМС',
    'Уровень пробиотиков и&nbsp;полезных бактерий',
    'Оценка состояния микрофлоры кишечника после приема антибиотиков',
    'Уровень защищенности от&nbsp;болезни Крона, язвенного колита, сахарного диабета 2 типа, ишемической болезни сердца и&nbsp;ожирения',
    'Способность бактерий расщеплять клетчатку, лактозу и&nbsp;глютен, синтезировать витамины',
    'Противовоспалительный потенциал микробиоты и&nbsp;синтез масляной кислоты',
    'Персональные рекомендации по&nbsp;продуктам питания, образу жизни, необходимым анализам и&nbsp;обследованиям',
    'Отслеживание здоровья микробиоты в&nbsp;динамике',
    'Влияние питания на&nbsp;состояние кишечной микрофлоры',
  ],
  [GOODS_TYPES.wgs]: [
    '368 наследственных и&nbsp;20 распространенных многофакторных заболеваний',
    '40 онкологических синдромов и&nbsp;метаболизм 99 лекарств',
    'Реакция на&nbsp;лактозу, глютен, алкоголь, кофеин, куриные яйца, коровье молоко и&nbsp;арахис',
    'Мужское и&nbsp;женское здоровье, уровни гормонов',
    'Спортивные риски, метаболизм, уровни витаминов и&nbsp;минералов',
    'Индивидуальные рекомендации по&nbsp;врачам, обследованиям и&nbsp;анализам',
    'Происхождение, гаплогруппы и&nbsp;поиск родственников до&nbsp;8 поколения',
  ],
}

const Intro = ({ translations: t, goodsType }) => {
  const { locale, paths, dict, sales } = useContext(LocalizationContext)
  const { goods, currency } = useGoods(locale)
  const { mobile } = useContext(ResizeContext)
  const event = useCurrentPromoEvent(locale)
  const isWgs = goodsType === GOODS_TYPES.wgs
  const isBiome = goodsType === GOODS_TYPES.biome
  const hasJuneBundleProductTheme = locale === RU && [
    GOODS_TYPES.dna,
    GOODS_TYPES.biome,
    GOODS_TYPES.wgs,
  ].includes(goodsType) && event?.code === EVENT_CODES.JUNE_BUNDLE_26
  const activeEventCode = hasJuneBundleProductTheme
    ? EVENT_CODES.JUNE_BUNDLE_26
    : event?.code
  const isDnaDay26Theme = activeEventCode === EVENT_CODES.DNA_DAY_26
  const isJuneBundle26Theme = activeEventCode === EVENT_CODES.JUNE_BUNDLE_26
  const theme = useTheme(activeEventCode, locale, isWgs, isBiome)
  const isBlackColor = theme.color === 'black'

  const formatter = useMemo(() => {
    if (!currency) return
    return createNumberFormatter({ locale, currency })
  }, [locale, currency])

  const currentGoodType = isBiome ? GOODS_TYPES.microbiome : isWgs ? 'dna_wgs' : goodsType

  const rawPrice = goods?.[currentGoodType]?.price
  const rawCurrentPrice = goods?.[currentGoodType]?.currentPrice
  const rawPriceWebsite = goods?.[currentGoodType]?.priceWebsite
  const price = rawPrice
  const currentPrice = rawCurrentPrice
  const discount = goods?.[currentGoodType]?.discount
  const isZeroPrice = goods?.[currentGoodType] && (
    rawCurrentPrice === 0 || rawPrice === 0 || rawPriceWebsite === 0)


  const content = useMemo(
    () => {
      if (isJuneBundle26Theme) {
        return JUNE_BUNDLE_PRODUCT_LISTS[goodsType]
      }

      return mobile
        ? dict.kits[goodsType].list_mob.filter(item => !!item)
        : dict.kits[goodsType].list.filter(item => !!item)
    },
    [goodsType, mobile, dict, isJuneBundle26Theme],
  )

  const sharedIllustrationPath = `${paths.shared}/product-illustrations/${
    goodsType === 'biome' ? 'microbiome' : goodsType
  }/${theme.illustration}_${locale}`
  const eventLabels = [
    'Бесплатная доставка',
    'Результаты в Личном кабинете + PDF',
    ...(isDnaDay26Theme || isJuneBundle26Theme
      ? []
      : [t.promo_label?.[activeEventCode] || t.promo_label?.[event?.code]].filter(Boolean)),
  ]
  const hasLabel = eventLabels.length > 0
  const hasDiscount = Boolean(discount) && !(isDnaDay26Theme && isWgs) && !isJuneBundle26Theme
  const localProductIllustrationSrc = goodsType === GOODS_TYPES.biome
    ? '/static/images/product-illustrations/microbiome/dna.png'
    : goodsType === GOODS_TYPES.wgs
      ? '/static/images/product-illustrations/wgs/dna.png'
      : '/static/images/product-illustrations/dna/dna.png'
  const hasLocalProductIllustration = isDnaDay26Theme || isJuneBundle26Theme
  const title = isJuneBundle26Theme && isWgs
    ? t.title.replace('Тест Полный геном. ', 'Тест Полный геном.<br />')
    : t.title

  return (
    <Wrapper
      $bg={theme.bg}
    >
      <Container $color={theme.color}>
        <Title
          isWgs={isWgs}
          isBiome={isBiome}
          isJuneBundle={isJuneBundle26Theme}
          weight={'medium'}
          size={['50/60', '50/60', '30/40']}
          forwardedAs={'h1'}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {!hasLocalProductIllustration ? (
          <Image
            path={sharedIllustrationPath}
            ext={'png'}
            customStyles={theme.customStyles}
            customStylesDesktop={theme.customStylesDesktop}
            customStylesTab={theme.customStylesTab}
            customStylesMob={theme.customStylesMob}
          />
        ) : (
          <Image
            $src={localProductIllustrationSrc}
            ext={'png'}
            customStyles={theme.customStyles}
            customStylesDesktop={theme.customStylesDesktop}
            customStylesTab={theme.customStylesTab}
            customStylesMob={theme.customStylesMob}
          />
        )}

        <Content>
          <List>
            {content.map(row => (
              <ListItem
                forwardedAs={'li'}
                size={['18/24', '18/24', '18/24']}
                key={row}
                dangerouslySetInnerHTML={{ __html: row }}
                className={theme.mark}
              />
            ))}
          </List>

          {(
            hasLabel || hasDiscount) && (
            <Event>
              {hasDiscount && !isZeroPrice && (
                <DiscountBadge bg={theme.badgeBg} color={theme.badgeColor}>
                  -{discount}%
                </DiscountBadge>
              )}

              {eventLabels.map((label, i) => (
                <EventLabel
                  key={i}
                  bg={theme.labelBg}
                  color={theme.labelColor}
                  dangerouslySetInnerHTML={{ __html: label }}
                />
              ))}
            </Event>
          )}

          <Actions isEvent={theme.illustration !== 'default'} buttonBg={theme.button}>
            {price !== currentPrice && !isZeroPrice && (
              <OldPrice
                className={classNames({
                  'h-color-D30': (isDnaDay26Theme || isJuneBundle26Theme) && !isWgs,
                  'h-color-D50': !isDnaDay26Theme && !isJuneBundle26Theme && isBlackColor,
                  'h-color-W50': (isDnaDay26Theme && isWgs) || (isJuneBundle26Theme && isWgs) || (!isDnaDay26Theme && !isJuneBundle26Theme && !isBlackColor),
                })}
                forwardedAs='h5'
                weight='medium'
                size={mobile ? '18/24' : '22/30'}
                decoration='line-through'
              >
                {formatter?.format(price)}
              </OldPrice>
            )}

            <PriceAndButton>
              {!isZeroPrice && (
                <Price
                  size={mobile ? '25/30' : '35/40'}
                  weight='medium'
                >
                  {formatter?.format(currentPrice)}
                </Price>

              )}

              <AddAndGoToCart
                goods={[
                  {
                    type: goodsType,
                    isSubscription: false,
                  },
                ]}
                buttonProps={{
                  bgClassName: `bg--${theme.button}`,
                  textClassName: `text--${theme.textButton}`,
                  withTopMarginOnMobile: true,
                  isDisabled: isZeroPrice,
                }}
                forceMultipleAdd={true}
              >
                <ButtonInner
                  as='span'
                  dangerouslySetInnerHTML={{
                    __html: sales.withoutSales || isZeroPrice
                      ? dict.buttons.out_of_stock
                      : locale === RU
                        ? dict.buttons.buy
                        : dict.buttons.add_to_cart,
                  }}
                />
              </AddAndGoToCart>
            </PriceAndButton>

            {locale === RU && !isZeroPrice && currentPrice > 0 && (
              <SplitBadgeWrapper>
                <yandex-pay-badge
                  merchant-id="200e987e-1ea6-4fef-8b8c-c890be94b929"
                  type="bnpl"
                  amount={currentPrice.toFixed(2)}
                  size="l"
                  variant="detailed"
                  theme={isBlackColor ? 'light' : 'dark'}
                  align="left"
                  color="primary"
                />
              </SplitBadgeWrapper>
            )}
          </Actions>
        </Content>
      </Container>
    </Wrapper>
  )
}

Intro.propTypes = {
  translations: PropTypes.shape({
    title: PropTypes.string,
  }),
  goodsType: PropTypes.string,
}

export default Intro
